import { DocumentViewOptionType } from "@/enums/enums";
import { Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class DisplayPaper extends VuexModule {
  public documentViewOption: DocumentViewOptionType = DocumentViewOptionType.FullScreen;

  get getDocumentViewOption() {
    return this.documentViewOption;
  }

  @Mutation
  public SetDocumentViewOption(option: DocumentViewOptionType) {
    this.documentViewOption = option;
  }
}
